import { Flex, font, themedColor } from '@lemonade-hq/cdk';
import React from 'react';
import styled from 'styled-components';
import { DocIcon } from './icons/Icons';

const DownloadLinksList = styled.ul`
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
  margin-top: -8px; // to reduce the space from 20px to 12px

  & > li {
    border-bottom: 1px solid ${themedColor('glass')};
  }

  & > li:last-child {
    border: none;
  }
`;

const DownloadLink = styled.a`
  ${font('main', { fontSize: '1.6rem' })};
  color: ${({ theme }) => theme.colors.primary};
  display: inline-flex;
  gap: 8px;
  align-items: center;
  padding-block: 18px;
`;

export interface DocsProps {
  docs: { file: string; name: string }[];
}
export const DocumentList: React.FC<DocsProps> = ({ docs }) => {
  return (
    <DownloadLinksList>
      {docs.map(({ file, name }) => (
        <li key={file}>
          <DownloadLink href={file} target="_blank" rel="noopener noreferrer">
            <Flex flexShrink={0}>
              <DocIcon />
            </Flex>
            {name}
          </DownloadLink>
        </li>
      ))}
    </DownloadLinksList>
  );
};
